import React, { useEffect } from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import Pagination from "../../Pagination";

const DeletedDomainData = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  deletedDomain,
  softDeleteRestoreCDISCStudyFinalDomains,
  pageNumberDeleted,
  itemsPerPageDeleted,
  deletedDomainCount,
  getDeletedDomainList,
  setPageNumberDeleted,
  setItemsPerPageDeleted,
}) => {
  const startIndex = (pageNumberDeleted - 1) * itemsPerPageDeleted;
  const totalPage = Math.ceil(deletedDomainCount / itemsPerPageDeleted);
  useEffect(() => {
    getDeletedDomainList(pageNumberDeleted, itemsPerPageDeleted);
  }, [pageNumberDeleted, itemsPerPageDeleted]);
  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 575 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {deletedDomain?.length === 0 ? (
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 44px)" }}
            >
              <NoDataFoundTable MSG={"Domains not deleted yet."} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Target Domain Class</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Target Domain Label</th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Target Domain Name</th>

                    <th
                      onMouseDown={(e) => onMouseDown(e, 4)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Restore
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {deletedDomain?.map((item, index) => (
                    <tr key={index} title={`Target Class Name: ${item?.targetDomainLabel}`}>
                      <td className="text-center">{index + 1 + startIndex}.</td>
                      <td>{item?.targetDomainLabel}</td>
                      <td>{item?.targetDomainLabel}</td>
                      <td>{item?.targetDomainName}</td>
                      <td
                        className="text-center CP"
                        title="Restore"
                        onClick={(e) =>
                          softDeleteRestoreCDISCStudyFinalDomains(item?._id, "restore")
                        }
                      >
                        <MdRestore
                          style={{ fontSize: 16 }}
                          className="text-success"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumberDeleted}
                  itemsPerPage={itemsPerPageDeleted}
                  totalItems={deletedDomainCount}
                  setPageNumber={setPageNumberDeleted}
                  setItemsPerPage={setItemsPerPageDeleted}
                />
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DeletedDomainData;
